export const FILE_SORTING_OPTIONS = [
  { label: 'Date Added', value: 'created_at' },
  { label: 'File name', value: 'aws_url_file_name' },
];

export default FILE_SORTING_OPTIONS;
